export function toTitleCase(str: string) {
	return str
		.toLowerCase()
		.replace(/(^|\s)\S/g, (t) => t.toUpperCase())
}

export * from '../../utils/request-manager'
export * from '../../utils/save-access-token'
